var React = require('react');

function Spinner (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33.51 66.99c18.47 0 33.5-15.02 33.5-33.5 0-1.48-1.2-2.68-2.68-2.68S61.64 32.01 61.64 33.5c0 15.51-12.62 28.13-28.13 28.13S5.38 49 5.38 33.5 18 5.37 33.51 5.37c7.87 0 15.27 3.32 20.53 8.93l-3.74-1c-1.43-0.38-2.9 0.46-3.29 1.9 -0.38 1.43 0.46 2.9 1.9 3.29l10.44 2.79c0.23 0.06 0.46 0.09 0.69 0.09 0.54 0 1.07-0.16 1.52-0.47 0.07-0.05 0.13-0.11 0.2-0.17 1.13-0.68 1.58-2.06 1.11-3.27l0.94-8.75c0.16-1.48-0.91-2.8-2.38-2.95 -1.47-0.16-2.8 0.91-2.95 2.38L58.18 10.88C51.9 4.05 42.99 0 33.5 0 15.02 0 0 15.02 0 33.5c0.01 18.47 15.03 33.5 33.51 33.5L33.51 66.99z"}));
}

Spinner.defaultProps = {"viewBox":"0 0 67 66.99"};

module.exports = Spinner;

Spinner.default = Spinner;
